import type { FetchError } from "ofetch"
import type { MaybeError, WrapData } from "~/types/generics"

/**
 * Handle the result and call a store action or handle error method.
 */
export function handleStoreResult<T = any>(res: MaybeError<FetchError<any>, WrapData<T>>, storeAction: (data: T) => void, handleError: (error: FetchError<any>) => any) {
    if (res.error) {
        return handleError(res.error)
    }
    storeAction(res.data)
}